<template lang="pug">
v-img(v-if="image", :src="image", @click="getUrl(imageUrl)", contain)
</template>
<script>
export default {
  name: "FBannerImageContent",
  props: ["value"],
  data() {
    return {
      banner: null,
      image: null,
      imageUrl: null,
    };
  },
  watch: {
    value(val) {
      this.doInitModel(val);
    },
  },
  mounted() {
    this.doInitModel(this.value);
  },

  methods: {
    doInitModel(values) {
      this.banner = values ? values : null;
      this.getImage(
        this.banner ? (this.banner.image ? this.banner.image : " ") : " "
      );
      this.imageUrl = this.banner
        ? this.banner.link
          ? this.banner.link
          : " "
        : " ";
    },
    getImage(path) {
      this.$http
        .get("/api/util/image/banner", {
          params: { fileName: path },
          responseType: "arraybuffer",
        })
        .then((success) => {
          let image = new Blob([success.data], {
            type: "image/jpeg;image/png",
          });
          this.image = window.URL.createObjectURL(image);
        });
    },
    getUrl(url) {
      window.location.href = url;
    },
  },
};
</script>